module.exports = __webpack_public_path__ + "img/旭瑞供热应急维修处理管理平台V1.0.64d5fba7.jpg";